import React, { Component } from 'react';

class Footer extends Component {
  year = new Date().getFullYear();

  render() {
    return (
      <footer>
        <p>
          © {this.year} Farmer for Zinha &amp; Nene
        </p>
      </footer>
    )
  }
}

export default Footer;